import { DataListItem } from '@brighte/form-components';
import { FINANCIAL_PRODUCT } from '@brighte/validation';
import { useApplicationData } from '@provider';
import { ELIGIBILITY, LABELS } from '@utils';

function useEligibilitySummary(): Array<{ title: string; items: DataListItem[] | [] }> | [] {
  const { quote, Eligibility: eligibility } = useApplicationData(['quote', 'Eligibility']);

  if (!eligibility) return [];

  const { SUMMARY_HEADER, CONFIRMED } = LABELS;
  const {
    HEADING_FINANCE_ELIGIBILITY,
    HEADING_FINANCE_ELIGIBILITY_BNPL,
    HEADING_PRIVACY_AND_ELECTRONIC_COMMUNICATION,
    CUSTOMER_DECLARATION_HEADING,
  } = ELIGIBILITY;

  // Each row echoes the heading of the section it confirms, so the finance heading has to follow the
  // same product split Terms makes — BrightePay reads "Finance eligibility", everything else
  // "Application eligibility".
  const isBnplApplication = quote?.financialProduct?.id === FINANCIAL_PRODUCT.BRIGHTE_PAY;
  const financeHeading = isBnplApplication ? HEADING_FINANCE_ELIGIBILITY_BNPL : HEADING_FINANCE_ELIGIBILITY;

  const confirmations = [
    { agreed: eligibility.agreeToFinanceTerms, label: financeHeading },
    { agreed: eligibility.agreeToPrivacyTerms, label: HEADING_PRIVACY_AND_ELECTRONIC_COMMUNICATION },
    { agreed: eligibility.agreeToCustomerDeclaration, label: CUSTOMER_DECLARATION_HEADING },
  ];

  const items: DataListItem[] = confirmations
    .filter(({ agreed }) => !!agreed)
    .map(({ label }) => ({ label, value: CONFIRMED }));

  if (!items.length) return [];

  return [{ title: SUMMARY_HEADER, items }];
}

export { useEligibilitySummary };
